import React from 'react';
import Layout from 'src/components/Layout';
import { TopbarStaticSpace } from 'src/components/Topbar';
import { Section, SectionOverlap, TwoColumns } from 'src/components/Section';
import { LearningAndTechno } from 'src/components/Bootcamp/index';
import { RecruitersSection } from 'src/components/Partners';
import { AnchorButton } from 'src/components/Button';
import { DescriptionBlock } from 'src/components/DescriptionBlock';
import { StaticImage } from 'gatsby-plugin-image';
import { ProjectsExamples } from 'src/components/Projects';

/* --- import Style ----*/
import { mediaQueries } from 'src/style/breakpoints';
import { BtnWrapper, HeroWrapper, HeroLeft } from 'src/components/Hero/elements';
import {
  H2,
  HeaderTitle,
  HeaderDescription,
  TextContainer,
  SectionTitle,
} from 'src/components/Typography';
import sizes from 'src/style/sizes';
import { CTAContainer, CTAInfoContent } from 'src/components/CTA/elements';
import { StarsCTAFooter } from 'src/components/Illustrations';
import { RocketIllustration } from 'src/components/Illustrations/RocketIllustration';

const Recruiters = ({ location }) => {
  return (
    <Layout
      pathname={location.pathname}
      businessType="B2B"
      pageName="Recrutement étudiants"
      pageType="form"
      metaTitle="Recrutez nos étudiants à la sortie de la formation | Le Reacteur"
      metaDescription="Les étudiants du Reacteur sont formés à la programmation Web et Mobile. Nous leur enseignons le JavaScript, HTML/CSS, Node.js, React et React Native. Déposez vos offres de recrutement en ligne !"
    >
      <TopbarStaticSpace />
      {/* <HeroBG80vh> */}
      <Section theme="primary" hero={true} margin>
        <HeroWrapper>
          <HeroLeft css={{ flex: 1 }}>
            <HeaderTitle>
              Recrutez votre prochain(e) alternant(e).
              <br />
              Nous vous accompagnons dans votre recherche.
            </HeaderTitle>
            <HeaderDescription
              css={{
                marginTop: 30,
                textAlign: 'center',
                [mediaQueries.desktopUp]: {
                  marginRight: 60,
                  textAlign: 'left',
                },
              }}
            >
              Le Reacteur, pionnier du bootcamp Web & Mobile en Europe, forme chaque année des
              développeurs juniors opérationnels et motivés, prêts à évoluer en alternance.
            </HeaderDescription>
            <BtnWrapper>
              <AnchorButton
                to="/deposer-une-offre-d-alternance/"
                css={{
                  marginRight: 20,
                  [mediaQueries.phoneOnly]: {
                    marginBottom: '20px',
                    width: '100%',
                    marginRight: 0,
                  },
                }}
              >
                <H2>Déposer une offre d'alternance</H2>
              </AnchorButton>

              <AnchorButton
                secondary
                to="/contact/"
                css={{
                  [mediaQueries.phoneOnly]: {
                    marginBottom: '20px',
                    width: '100%',
                  },
                }}
              >
                Nous contacter
              </AnchorButton>
            </BtnWrapper>
          </HeroLeft>
        </HeroWrapper>
      </Section>
      {/* </HeroBG80vh> */}

      <SectionOverlap marginTop={-100} theme="secondary">
        <SectionTitle css={{ padding: '60px 0px 60px 0px' }}>
          Pourquoi choisir nos étudiants ?
        </SectionTitle>
        <TwoColumns
          sizeLeft={sizes.columnWidth.medium}
          left={
            <div>
              <DescriptionBlock title="Ils maitrisent une stack robuste et adaptée aux besoins du marché">
                Formés intensivement sur les technologies phares des startups : HTML, CSS,
                JavaScript, Node.js, Express, MongoDB, React et React Native. Ils savent aussi
                exploiter l’IA générative pour accélérer la production de code et enrichir leurs
                projets.
              </DescriptionBlock>
              <StaticImage
                src="../../src/data/images/2023_students8.jpg"
                alt="Recruter les élèves du Reacteur"
                // placeholder="none"
                css={{
                  flex: 1,
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 5,
                  marginTop: 20,
                  boxShadow: '5px 20px 40px rgba(0, 0, 0, 0.2)',
                  [mediaQueries.phoneOnly]: {
                    height: '70%',
                  },
                  [mediaQueries.tabletPortraitUp]: {
                    height: '60%',
                  },
                  [mediaQueries.tabletLandscapeUp]: {
                    height: 340,
                  },
                }}
              />
            </div>
          }
          sizeRight={sizes.columnWidth.medium}
          right={
            <div>
              <div>
                <DescriptionBlock title="Motivation, autonomie et esprit maker">
                  Nos étudiants sont sélectionnés pour leur curiosité, leur motivation et leur
                  capacité à se dépasser. Ils ont appris à apprendre, à trouver des solutions par
                  eux-mêmes et à travailler efficacement en équipe. Leur parcours en bootcamp leur a
                  inculqué la rigueur, l’adaptabilité et l’envie constante de progresser. En
                  alternance, cette énergie se traduit par une réelle valeur ajoutée pour votre
                  entreprise dès les premiers jours.
                </DescriptionBlock>
              </div>

              <DescriptionBlock title="Projets concrets et opérationnels">
                En fin de formation, nos étudiants réalisent plusieurs projets complets qui couvrent
                un large éventail de cas réels : outils métiers, applications web et mobiles,
                prototypes fonctionnels ou encore automatisations de processus. Ces projets leur
                permettent de mettre en pratique l’ensemble des compétences acquises, de gérer un
                développement de bout en bout et d’être immédiatement opérationnels sur des missions
                en entreprise.
              </DescriptionBlock>
            </div>
          }
        />
      </SectionOverlap>

      <LearningAndTechno title="Voici ce que nos étudiants apprennent en formation" />

      <ProjectsExamples theme="secondary" recruitersSection={true} />

      <RecruitersSection title="Ils ont recruté nos élèves" theme="light" />

      <Section theme="primary">
        <CTAContainer>
          <RocketIllustration />
          <StarsCTAFooter />
          <CTAInfoContent>
            <SectionTitle isCenter={true}>
              Et si vous recrutiez <br /> un de nos élèves{' '}
              <br
                css={{
                  display: 'none',
                  [mediaQueries.phoneOnly]: {
                    display: 'block',
                  },
                }}
              />
              en alternance ?
            </SectionTitle>
            <div
              css={{
                padding: '0px 0px 40px 0px',
                maxWidth: 600,
                margin: '0 auto',
              }}
            >
              <TextContainer style={{ textAlign: 'center' }}>
                Vous recherchez un Développeur Full Stack, un développeur front-end, ou un
                développeur back-end ? Commencez par remplir notre formulaire de contact et nous
                vous contacterons.
              </TextContainer>
            </div>

            <AnchorButton to="/deposer-une-offre-d-alternance/">
              Déposer une offre d'alternance
            </AnchorButton>
          </CTAInfoContent>
        </CTAContainer>
      </Section>
    </Layout>
  );
};
export default Recruiters;

// export const query = graphql`
//   query {
//     image: file(relativePath: { eq: "image17.jpg" }) {
//       childImageSharp {
//         gatsbyImageData(quality: 80, width: 1300)
//       }
//     }
//   }
// `;
